module.exports = __webpack_public_path__ + "static/media/GeneracInverter.bdcb9540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GeneracInverter.jpg
// module id = 1093
// module chunks = 0